import React, { useEffect, useContext } from 'react';
import Home from '../components/Home/Home';
import { AirtimePlanningContext } from '../contexts/AirtimePlanningContext';

const HomePage = () => {
    const { setPropertyStats, setPropertyTotals } = useContext(AirtimePlanningContext);
    useEffect(() => {
        setPropertyStats([]);
        setPropertyTotals({});
    }, []);
    return <Home />;
};

export default HomePage;
